module.exports = __webpack_public_path__ + "static/media/icon-calendar-active.292f90f1.svg";